import { observer } from "mobx-react-lite";
import React from "react";
import InfluencerProvider from "../../../contexts/InfluencerContext";
import { useSidebarCollapse } from "../../../contexts/SidebarCollapseContext";
import AuthenticationsPage from "./AuthenticationsPage";
import InfluencerHeader from "./InfluencerHeader";
import InfluencerSidebar from "./InfluencerSidebar";

export default observer(function InfluencerPage() {
  const { isCollapsed } = useSidebarCollapse();
  return (
    <InfluencerProvider>
      <InfluencerSidebar />
      <div
        className={`pt-12 ${isCollapsed ? "pl-14" : "pl-56"} dark:bg-rb-dark-mode transition-all duration-300`}
      >
        <InfluencerHeader />
        <AuthenticationsPage />
      </div>
    </InfluencerProvider>
  );
});
